<div *ngIf="successMessage" class="alert alert-success" role="alert">
	<mat-icon>thumb_up</mat-icon> &nbsp;
	<span style="vertical-align: text-bottom; margin-bottom: 0rem;">
		{{successMessage}}
	</span>
</div>

<div *ngIf="errorMessage" class="alert alert-danger" role="alert">

	<span style="vertical-align: text-bottom; margin-bottom: 0rem;">
		{{errorMessage}}
	</span>
</div>


<div class="row_1">
	<div class="top_grid_agg">
		<div class="content">
          <div style="width: 50%; justify-content: left; display: flex;">
            <button routerLink="/newtask" class="back_button col-sm-1">BACK</button>
          </div>
		  <div style="width: 50%; justify-content: right; display: flex;">
            <button *ngIf="activateAdd" class="add_button col-sm-1 float-right" (click)="addtask()">ADD TASK</button>
			<button *ngIf="activateSave" class="add_button col-sm-1 float-right" (click)="savetask()">SAVE</button>
          </div>
        </div>
		<div class="period-form">
			<form class="form-horizontal hr">
				<div class="form-group row">
					<div class="col-sm-6">

						<div class="board-row">
							<label class="control-label col-sm-4">Board:
								<span style="color:#ff0000">*</span>
							</label>
							<div class="col-sm-8">
								<select [(ngModel)]="selected_board" [ngModelOptions]="{standalone: true}">
									<option *ngFor="let board of boardData" [value]="board.boardID">
										{{board.description}}
									</option>
								</select>
							</div>
						</div>

						<div class="period-row">
							<label class="control-label col-sm-4">Period:
								<span style="color:#ff0000">*</span>
							</label>
							<div class="col-sm-8">
								<select [(ngModel)]="selected_period" [ngModelOptions]="{standalone: true}">
									<option *ngFor="let period of periodData" [value]="period.periodId">
										{{period.name}} {{period.year}}
									</option>
								</select>

							</div>
						</div>
						<div class="task-row">
							<label class="control-label col-sm-4">Task:
								<span style="color:#ff0000">*</span>
							</label>
							<div class="col-sm-8">
								<!-- <select class="category" [(ngModel)]="selectedTask"
									[ngModelOptions]="{standalone: true}">
									<option *ngFor="let task of taskData" [value]="task.taskID">
										{{task.description}}
									</option>
								</select> -->
								<!-- <p-dropdown id="taskdropdown" [options]="taskDataDrpDwn" optionLabel="label"
									panelStyleClass="widthOverride" [(ngModel)]="selectedTask" [filter]="true"
									[virtualScroll]="true" itemSize="30" [showTransitionOptions]="'0ms'"
									placeholder="Select" [hideTransitionOptions]="'0ms'" autoWidth="false"
									[resetFilterOnHide]="true" [ngModelOptions]="{standalone: true}"></p-dropdown> -->

								<mat-form-field appearance="outline" class="fixed-select">
									<mat-select [(ngModel)]="selectedTask" placeholder="Select" name="taskSelect"
										panelClass="custom-task-panel">

										<!-- Search -->
										<mat-option disabled>
											<ngx-mat-select-search [formControl]="taskFilter" placeholderLabel="Search"
												noEntriesFoundLabel="No User found">
											</ngx-mat-select-search>
										</mat-option>

										<!-- Options -->
										<mat-option *ngFor="let user of filteredTasks | async" [value]="user">
											{{ user.label }}
										</mat-option>

									</mat-select>
								</mat-form-field>
							</div>
						</div>
						<div class="dDay-row">
							<label class="control-label col-sm-4">D-Day:</label>
							<div class="col-sm-8">
								<input type="number" [(ngModel)]="selected_dday" [ngModelOptions]="{standalone: true}">
							</div>
						</div>

						<div class="due-row">
							<label class="control-label col-sm-4" aria-describedby="due-desc">Due Time:
								<p class="due-desc">(Leave blank for midnight) &nbsp;</p>
							</label>

							<div class="col-sm-8">
								<!-- time dropdown -->
								<select id="category-drop-down" class="dueTime" [(ngModel)]="selected_duetime"
									[ngModelOptions]="{standalone: true}">
									<option [value]="option" *ngFor="let option of options">{{option}}</option>
								</select>
							</div>
						</div>

						<div class="sequence-row">
							<label class="control-label col-sm-4">Sequence:</label>
							<div class="col-sm-8">
								<input type="number" min="0" max="99" [(ngModel)]="selected_sequence"
									[ngModelOptions]="{standalone: true}">
							</div>
						</div>

						<div class="primaryuser-row">
							<label class="control-label col-sm-4">Primary User:
								<span *ngIf="s_region_flag" style="color:#ff0000">*</span>
							</label>
							<div class="col-sm-8">
								<!-- <p-dropdown id="puserdropdown" [options]="userdropdown" optionLabel="label"
									panelStyleClass="widthOverride" [(ngModel)]="selected_puser" [filter]="true"
									[virtualScroll]="true" itemSize="30" [showTransitionOptions]="'0ms'"
									placeholder="Select" [hideTransitionOptions]="'0ms'" autoWidth="false"
									[resetFilterOnHide]="true" [ngModelOptions]="{standalone: true}" appendTo="body"
									[showClear]="true">
								</p-dropdown> -->
								<mat-form-field appearance="outline" class="fixed-select">
									<mat-select [(ngModel)]="selected_puser" placeholder="Select" name="puserSelect">

										<mat-option disabled>
											<div
												style="display: flex; align-items: center; position: sticky; top: 0; background: white; z-index: 2; width: 100%;">

												<ngx-mat-select-search [formControl]="puserFilter"
													placeholderLabel="Search" noEntriesFoundLabel="No User found"
													style="flex: 1;">
												</ngx-mat-select-search>
											</div>
										</mat-option>
										<div style="max-height: 200px; overflow-y: auto;">
											<mat-option *ngFor="let user of filteredPusers | async" [value]="user">
												{{ user.label }}
											</mat-option>
										</div>
									</mat-select>
								</mat-form-field>

							</div>
						</div>

						<div class="secondaryuser-row">
							<label class="control-label col-sm-4">Secondary User:</label>
							<div class="col-sm-8">
								<!-- <p-dropdown id="suserdropdown" [options]="userdropdown" optionLabel="label"
									panelStyleClass="widthOverride" [(ngModel)]="selected_suser" [filter]="true"
									[virtualScroll]="true" itemSize="30" [showTransitionOptions]="'0ms'"
									placeholder="Select" [hideTransitionOptions]="'0ms'" autoWidth="false"
									[resetFilterOnHide]="true" [ngModelOptions]="{standalone: true}" appendTo="body"
									[showClear]="true">
								</p-dropdown> -->
								<mat-form-field appearance="outline" class="fixed-select">
									<mat-select [(ngModel)]="selected_suser" placeholder="Select" name="suserSelect">

										<mat-option disabled>
											<div
												style="display: flex; align-items: center; position: sticky; top: 0; background: white; z-index: 2; width: 100%;">

												<ngx-mat-select-search [formControl]="suserFilter"
													placeholderLabel="Search" noEntriesFoundLabel="No User found"
													style="flex: 1;">
												</ngx-mat-select-search>
											</div>
										</mat-option>
										<div style="max-height: 200px; overflow-y: auto;">
											<mat-option *ngFor="let user of filteredSusers | async" [value]="user">
												{{ user.label }}
											</mat-option>
										</div>
									</mat-select>
								</mat-form-field>
							</div>
						</div>

					</div>
					<div class="col-sm-6">

						<div class="region-row">
							<label class="control-label col-sm-4 " for="fname">Region:
								<span *ngIf="!selected_puser" style="color:#ff0000">*</span>
							</label>
							<div class="multiselect col-sm-8">
								<!-- <p-multiSelect [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"
								[filter]="true" [options]="selectedRegions" optionLabel="label"
								[virtualScroll]="true" itemSize="30" autoWidth="false"
								[style]="{'width':'242px', 'height':'25px'}" [(ngModel)]="selected_region"
								defaultLabel="--Select Region(s)--" [ngModelOptions]="{standalone: true}"
								(onChange)="flagFunc()">
							</p-multiSelect> -->
								<mat-form-field appearance="outline" class="fixed-select">
									<mat-select [(ngModel)]="selected_region" [multiple]="true" name="regionSelect"
										placeholder="Select Region(s)" (selectionChange)="flagFunc()">

										<!-- Sticky Select All with Search Row -->
										<mat-option disabled>
											<div
												style="display: flex; align-items: center; position: sticky; top: 0; background: white; z-index: 2; width: 100%;">
												<!-- Real checkbox -->
												<mat-checkbox [checked]="isAllSelected()"
													[indeterminate]="isIndeterminate()"
													(change)="toggleSelectAll($event)" style="margin-right: 8px;">
												</mat-checkbox>

												<!-- Search box -->
												<ngx-mat-select-search [formControl]="regionFilterCtrl"
													placeholderLabel="Search" noEntriesFoundLabel="No regions found"
													style="flex: 1;">
												</ngx-mat-select-search>
											</div>
										</mat-option>

										<!-- Options -->
										<div style="max-height: 200px; overflow-y: auto;">
											<mat-option *ngFor="let user of filteredRegions | async" [value]="user">
												{{ user.label }}
											</mat-option>
										</div>
									</mat-select>
								</mat-form-field>

							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>